import React from 'react';
import ReactDOM from 'react-dom';

import { Link } from 'react-router-dom';
import Masthead from '@bd-uikit-web/React/Masthead';
import bdAuth from '@bd-uikit-web/js-helpers/bdAuth';

import './sidebar.scss';

export default class Sidebar extends Masthead {
  constructor(props) {
    super(props);
    this.history = props.props.history;
  }

  getDisplayName() {
    const user = bdAuth.getUser();
    if (!user) {
      return null;
    }
    return user.givenName || user.email;
  }

  getNavComponents() {
    const activeRoute = this.props.activeRoute;
    const navItems = this._navItems;
    const navComponents = [];

    // construct nav components
    for (const [idx, item] of navItems.entries()) {
      let baseClass = 'sidebar__li';
      const iconClass = `sidebar__icon ion-${item.icon}`;

      if (activeRoute === item.route) {
        baseClass += ' sidebar__li--active';
      }

      navComponents.push(
        <li key={idx} className={baseClass}>
          <Link to={`/${item.route}`}>
            <span className={iconClass}></span>
            {item.title}
          </Link>
        </li>
      );
    }

    return navComponents;
  }

  getAvatar() {
    const user = bdAuth.getUser();
    if (!user || !user.media) {
      return '/assets/img/person-silhouette.svg';
    }
    return user.media.images.avatar.low;
  }

  logout() {
    bdAuth.clear();
    this.history.push('/login');
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.activeRoute !== nextProps.activeRoute) {
      this.props.onCloseClick();
    }
    const node = ReactDOM.findDOMNode(this);
    if (nextProps.open) {
      node.classList.add('sidebar__visible');
    } else {
      node.classList.remove('sidebar__visible');
    }
  }

  render() {
    return (
      <aside className="sidebar">
        <button
          className = "sidebar__close ion-close" onClick = {() => this.props.onCloseClick()}
        ></button>
        <header className="sidebar__header">
          <div className="sidebar__avatar">
            <img src={this.getAvatar()} role="presentation" />
          </div>
          <div className="sidebar__name">
            <h6 className="h--lower h--no-spacing">Hi, {this.getDisplayName()}</h6>
            <small><a onClick={() => this.logout()}>Logout</a></small>
          </div>
          <div className="clear"></div>
        </header>
        <ul className="sidebar__nav ">
          {this.getNavComponents()}
          {/* <li className = "sidebar__li sidebar__show-on-collapse" >
            <a href="https://shop.blackdove.com/" target="_blank">
            <span className="sidebar__icon ion-bag "></span>
              Store
            </a>
          </li> */}
          <li className = "sidebar__li  sidebar__show-on-collapse">
            <a href="https://artist.blackdove.com/register" target="_blank">
              <span className="sidebar__icon ion-easel"></span>
                 Artist Portal
            </a>
          </li>
        </ul>
      </aside>
    );
  }
}
